module.exports = __webpack_public_path__ + "static/media/logo-decathlon.7a3c6e95.jpg";